import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController, AlertController, Loading, normalizeURL } from 'ionic-angular';
import { DuvidasSugestoesModel } from './duvidas-sugestoes.modelview';
import { CameraOptions, Camera } from '@ionic-native/camera';
import { DuvidasSugestoesPageProvider } from './duvidas-sugestoes.provider';
import { DomSanitizer } from '@angular/platform-browser';
import { Validators, FormBuilder } from '@angular/forms';
import { Platform } from 'ionic-angular';
import { normalizeUrl } from 'ionic-angular/umd/navigation/deep-linker';


/**
 * Generated class for the DuvidasSugestoesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-duvidas-sugestoes',
  templateUrl: 'duvidas-sugestoes.html',
})
export class DuvidasSugestoesPage {
  isBrowser: boolean = false;
  model: DuvidasSugestoesModel = new DuvidasSugestoesModel()
  form

  isPlatformBrowser = false
  isToSelectFile = false
  noNormalizedImage: string


  constructor(private navCtrl: NavController,
    private navParams: NavParams,
    private toastCtrl: ToastController,
    private alertController: AlertController,
    private camera: Camera,
    private sanitizen: DomSanitizer,
    private formBuilder: FormBuilder,
    private provider: DuvidasSugestoesPageProvider,
    private loadingCtrl: LoadingController,
    private platform: Platform
  ) {

    this.form = formBuilder.group({
      telefone: ['', Validators.required],
      email: ['', Validators.compose([Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'), Validators.required])],
      assunto: ['', Validators.required],
      mensagem: ['', Validators.required],
    });

    this.isBrowser = this.navParams.get("isBrowser")
    this.isPlatformBrowser = this.platform.is('core') || this.platform.is('mobileweb')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DuvidasSugestoesPage');
    this.solicitarListas()

    this.solicitarDadosUsuario()
  }

  solicitarDadosUsuario() {
    this.provider.getUserData().subscribe(user => {
      this.model.email = user.general.data.user_email
      this.model.telefone = user.acf.celular
    })
  }

  solicitarListas() {

    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present()

    this.provider.requestLists().subscribe((data) => {
      loading.dismiss()
      this.model.assuntos = data.assuntos_email
    }, err => {
      loading.dismiss().then(() => {
        let toast = this.toastCtrl.create({
          duration: 3000,
          message: "Erro ao carregar as listas!",
        });
        toast.present()
      })
    })
  }

  uploadImage() {

    if (this.isPlatformBrowser) {
      this.isToSelectFile = true
      return
    }

    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      correctOrientation: true,
      saveToPhotoAlbum: true,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY
    }

    this.camera.getPicture(options).then((imageData) => {
      this.model.anexo = normalizeURL(imageData)

      if (this.platform.is("ios"))
        this.noNormalizedImage = imageData
    }).catch(error => {
    })
  }

  requestSupport() {

    let loading = this.loadingCtrl.create({
      content: 'Enviando...'
    });
    loading.present()

    if (this.isPlatformBrowser) {
      this.sendFormRequest(loading)
      return
    }

    if (this.model.anexo != undefined && this.model.anexo.indexOf("http") < 0) {

      //Cloning Obj
      let objString = JSON.stringify(this.model)
      let modelToSend: DuvidasSugestoesModel = JSON.parse(objString)

      if (this.noNormalizedImage != undefined) {
        modelToSend.anexo = this.noNormalizedImage
      }

      this.provider.sendImage(modelToSend.anexo).subscribe(data => {
        console.log("sendImage", data)
        this.model.anexo = data
        this.sendFormRequest(loading)
      }, error => {
        loading.dismiss()
      })

    } else {
      this.sendFormRequest(loading)
    }

  }

  sendFormRequest(loading: Loading) {

    this.provider.requestSupport(this.model).subscribe(data => {
      loading.dismiss().then(() => {
        let toast = this.toastCtrl.create({
          message: "Enviado com sucesso!",
          duration: 3000,
          position: 'bottom'
        });
        toast.present()
      })
    }, error => {
      loading.dismiss().then(() => {
        this.showErrorDialog(error.message)
      })
    })
  }

  showErrorDialog(mess: string) {
    let alert = this.alertController.create({
      title: 'Erro',
      message: mess,
      buttons: [
        {
          text: 'Fechar',
          role: 'cancel',
          handler: () => {
            alert.dismiss()
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  changeListener(event: any) {

    let loading = this.loadingCtrl.create({
      content: 'Aguarde...'
    });
    loading.present().then(() => {
      console.log("Selected Image", event)
      let file = event.target.files[0];
      console.log("Selected Image file", file)

      this.provider.sendImageFile(file).subscribe(data => {
        console.log("sendImage", data)
        loading.dismiss()
        this.model.anexo = data
      }, error => {
        loading.dismiss()
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/duvidas-sugestoes/duvidas-sugestoes.ts